import { Card, Flex, Space } from 'antd'
import { FC } from 'react'
import { Strategy } from '../helpers/get-strategy'
import formatIntegerBySpace from '../../../../../../../../helpers/formatters/format-integer-by-space'

interface StrategyCardProps {
    strategy: Strategy
}

export const StrategyCard: FC<StrategyCardProps> = ({ strategy }) => {
    const { title, copies, winding, cols, rolls } = strategy

    return (
        <Card style={{ width: 170 }} key={title} size={'small'}>
            <Space style={{ width: '100%' }} direction={'vertical'}>
                <b>{title.replace('Стратегия ', '')}</b>
                <div>
                    <Flex gap={24} justify={'space-between'}>
                        <span>Тираж</span> <span>{copies}</span>
                    </Flex>
                    <Flex gap={24} justify={'space-between'}>
                        <span>Намотка</span>{' '}
                        <span>{formatIntegerBySpace(Math.floor(winding))}</span>
                    </Flex>
                    <Flex gap={24} justify={'space-between'}>
                        <span>Ручьи</span> <span>{cols}</span>
                    </Flex>
                    <Flex gap={24} justify={'space-between'}>
                        <span>Ролики</span>{' '}
                        <Flex vertical>
                            {rolls.map(([copies, amount]) => (
                                <span key={amount + copies}>
                                    {amount} по {Math.floor(copies)}
                                </span>
                            ))}
                        </Flex>
                    </Flex>
                </div>
                {/* <Button size={'small'} title={'Сейчас при нажатии ничего не происходит'}>
                    Выбрать
                </Button> */}
            </Space>
        </Card>
    )
}
